import seriveFactory from './service';
import { Notification } from 'element-ui';
const API = seriveFactory({
  // baseURL: window._env_.VUE_APP_APIBASEURL + '/overseaswpcapi/',
  baseURL: window._env_.VUE_APP_APIBASEURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json', // application/x-www-form-urlencoded ,  application/json multipart/form-data
    sysId: 'ae0eed67701b458c8967b4d34207d011',
  }
}, function (json, error) {
  // if (json) {
  //   if (json.status === '401') {
  //     let env = process.env.NODE_ENV;
  //     if (env === 'pro') {
  //       window.location.href = `https://www.ruijienetworks.com/login.aspx?r=${window.location.href}`;
  //     } else {
  //       window.location.href = 'changuser';
  //     }
  //   } else if (json.status === '403') {
  //     window.location.href = '403';
  //   }
  // }
  Notification.error({
    message: json.error || json.err || '请求服务器失败'
  });
});
export default API;
